export default "__VITE_ASSET__BKIQ_vmy__"